import React, { useState, useEffect } from "react";
import { Form, Modal, Button } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { useParams } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { API_URL } from "../../../constants";
import { FaSpinner } from "react-icons/fa";
import {
  GetServiceCaller,
  PostServiceCaller,
} from "../../../services/serviceCaller";
import { useDispatch } from "react-redux";
import { updateNavbarHeading } from "../../../constants/layout/store/filterSlice";

const CourseMasterForm = () => {
  const dispatch = useDispatch();
  const { id } = useParams();
  const navigate = useNavigate();
  useEffect(() => {
    dispatch(updateNavbarHeading(`${id ? "Edit" : "Add"} Skill Master`));
  }, []);
  // const { id } = useParams();
  // const navigate = useNavigate();
  const [errors, setErrors] = useState({});
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [deleteIndex, setDeleteIndex] = useState(null);
  const [filteredSuggestions, setFilteredSuggestions] = useState([]);
  const [suggestions, setSuggestions] = useState([]);
  const [showSuggestions, setShowSuggestions] = useState(false);
  const [pageLoading, setPageLoading] = useState(true);
  const initialFormData = {
    Code: "",
    Name: "",
    Description: "",
    IsInActive: 0,
    lines: [
      {
        LineNo: 1, // Ensure initial LineNo is set
        SubSkill: "",
        Remark: "",
        IsInActive: 0,
      },
    ],
  };
  const [formData, setFormData] = useState(initialFormData);
  console.log("formData::", formData);

  useEffect(() => {
    if (id) {
      fetchData(id);
    }
  }, [id]);

  const fetchData = async (id) => {
    try {
      const response = await GetServiceCaller(`${API_URL}skill-masters/${id}`);
      if (response.status === 200) {
        const { Code, Name, Description, IsInActive } =
          response?.data?.data?.skills || {};
        const courseVersion = response?.data?.data?.subskill || [];

        const lines = courseVersion.map((item, index) => ({
          LineNo: index + 1,
          ID: item.ID,
          SkillID: item.SkillID,
          SubSkill: item.SubSkill || "",
          IsInActive: item.IsInActive || "",
          Remark: item.Remark || "",
        }));

        setFormData({
          Code,
          Name,
          Description,
          IsInActive: IsInActive === 1 ? 1 : 0,
          lines,
        });
      } else {
        console.error(
          "Failed to fetch course details. Server responded with status:",
          response.status
        );
      }
    } catch (error) {
      console.error("Error fetching course details:", error);
    }
  };
  useEffect(() => {
    fetchSkills();
  }, []);
  const fetchSkills = async () => {
    try {
      const response = await GetServiceCaller(`${API_URL}skill-masters`);
      if (response.status === 200) {
        setPageLoading(false);
        const data = response?.data?.data;
        const allNames = data.map((item) => item.Name);
        setSuggestions(allNames);
      } else {
        console.error(
          "Failed to fetch skills. Server responded with status:",
          response.status
        );
      }
    } catch (error) {
      console.error("Error fetching skills:", error);
    }
  };

  const handleChange = (e, index) => {
    const { name, type, checked, value } = e.target;
    // const updatedLines = [...formData.lines];
    const newValue = type === "checkbox" ? (checked ? 1 : 0) : value;

    const updatedLines = formData.lines.map((line, i) =>
      i === index ? { ...line, [name]: newValue } : line
    );

    setFormData((prevState) => ({
      ...prevState,
      lines: updatedLines,
    }));

    setErrors((prevErrors) => {
      const newErrors = { ...prevErrors };
      if (name === "SubSkill") {
        delete newErrors[`SubSkill${index}`];
      }
      return newErrors;
    });
  };

  const handleNameChange = (e) => {
    const { value, name } = e.target;

    if (name === "Name") {
      const matchedSuggestions = suggestions.filter((suggestion) =>
        suggestion.toLowerCase().includes(value.toLowerCase())
      );
      setFilteredSuggestions(matchedSuggestions);
      setShowSuggestions(value.length > 0 && matchedSuggestions.length > 0);
    }
    setFormData((prevState) => ({
      ...prevState,
      Name: value,
    }));

    setErrors((prevErrors) => {
      const newErrors = { ...prevErrors };
      delete newErrors.Name;
      return newErrors;
    });
  };

  const handleDeleteLine = async () => {
    if (deleteIndex !== null) {
      const lineToDelete = formData.lines[deleteIndex];
      if (lineToDelete.ID) {
        try {
          const response = await PostServiceCaller(
            `${API_URL}skill-masters/${lineToDelete.ID}`,
            formData,
            "delete"
          );

          if (response.status === 200) {
            const updatedLines = formData.lines.filter(
              (_, i) => i !== deleteIndex
            );
            setFormData((prevState) => ({
              ...prevState,
              lines: updatedLines,
            }));
            toast.success("Subskill deleted successfully!");
          } else {
            throw new Error("Failed to delete the line");
          }
        } catch (error) {
          console.error(
            "There was a problem with the delete operation:",
            error
          );
          toast.error("Failed to delete the subskill. Please try again.");
        }
      } else {
        const updatedLines = formData.lines.filter((_, i) => i !== deleteIndex);
        setFormData((prevState) => ({
          ...prevState,
          lines: updatedLines,
        }));
        toast.success("Subskill removed successfully!");
      }
      setShowDeleteModal(false);
      setDeleteIndex(null);
    }
  };
  const handleAddLine = () => {
    const currentRow = formData.lines[formData.lines.length - 1];
    
    if (!currentRow) {
      setFormData((prevState) => ({
        ...prevState,
        lines: [
          {
            LineNo: 1,
            SubSkill: "",
            Remark: "",
            IsInActive: 0,
          },
        ],
      }));
      return;
    }
    
    if (currentRow.SubSkill === "") {
      toast.error("Please fill in the current row.", {
        position: "top-right",
      });
      return;
    }

    // Calculate the next LineNo based on the length of the lines
    const nextLineNo = formData.lines.length + 1;

    setFormData((prevState) => ({
      ...prevState,
      lines: [
        ...prevState.lines,
        { LineNo: nextLineNo, SubSkill: "", Remark: "", IsInActive: 0 }, // Use nextLineNo here
      ],
    }));
  };

  const handleCancel = () => {
    navigate("/skill-master");
  };

  const validateForm = () => {
    const newErrors = {};
    if (!formData.Name) newErrors.Name = "Skill Name is required";

    // Iterate through lines to check SubSkill
    formData.lines.forEach((line, index) => {
      if (!line.SubSkill) {
        newErrors[`SubSkill${index}`] = "Sub Skill is required";
      }
    });

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      const inputElement = document.getElementById("Name");
      const suggestionsElement = document.querySelector(
        ".suggestions-container"
      );

      // Close suggestions if click is outside both input and suggestions
      if (
        showSuggestions &&
        !inputElement.contains(event.target) &&
        (!suggestionsElement || !suggestionsElement.contains(event.target))
      ) {
        setShowSuggestions(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [showSuggestions]);

const handleSubmit = async (e) => {
  e.preventDefault();

  if (validateForm()) {
    const method = id ? "put" : "post";
    const apiUrl = id
      ? `${API_URL}skill-masters/${id}`
      : `${API_URL}skill-masters`;

    try {
      const response = await PostServiceCaller(apiUrl, formData, method);
      
      // Check for successful response (multiple success indicators)
      if (response && (response.status === "success" || response.status === 200 || response.statusCode === 200)) {
        const successMessage = "Data submitted successfully";
        toast.success(successMessage);
        
        // Reset form data after submission
        setFormData(initialFormData);

        // Delay redirect to '/skillmaster' to allow success message display
        setTimeout(() => {
          window.location.href = "/skill-master";
        }, 2000);
      } else {
        // Show API's error message if available
        const errorMessage = response?.message || response?.data?.message;
        console.error("API error:", errorMessage);
        toast.error(errorMessage);
      }
    } catch (error) {
      const msg = error?.response?.data?.message
        || error?.response?.data?.errors
        || "Submission failed";
      toast.error(typeof msg === 'object' ? Object.values(msg).flat().join(', ') : msg);
    }
  }
};
  if (pageLoading) {
    return (
      <>
        <p class="position-absolute top-50 start-50 translate-middle text-center">
          <FaSpinner class="spinner" />
        </p>
      </>
    );
  } else {
  return (
    <>
      <div className="container-fluid" id="skill_section">
        <div className="container-fluid" id="skill-table-area">
          <div className="row">
            <ToastContainer />
            <Form onSubmit={handleSubmit}>
              <div className="row">
                <div className="col-12 col-xl-5">
                  <div className="row">
                    <div className="col-4">
                      <div class="mb-3">
                        <label for="Name" class="form-label">
                          Code
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          id="Code"
                          aria-describedby="Code"
                          name="Code"
                          placeholder="Code"
                          value={formData.Code}
                          disabled
                          onChange={(e) =>
                            setFormData({ ...formData, Code: e.target.value })
                          }
                        />
                      </div>
                    </div>
                    <div className="col-8">
                      <div class="mb-3">
                        <label for="Name" class="form-label">
                          Skill Name<span className="required">*</span>
                        </label>
                        <input
                          type="text"
                          className={`form-control ${
                            errors.Name ? "is-invalid" : ""
                          }`}
                          id="Name"
                          aria-describedby="Name"
                          name="Name"
                          placeholder="Skill Name"
                          value={formData.Name}
                          onChange={handleNameChange}
                          autoComplete="off"
                        />
                        {showSuggestions && filteredSuggestions.length > 0 && (
                          <div
                            className="suggestions-container"
                            style={{
                              position: "absolute",
                              width: "26%",
                              maxHeight: "200px",
                              overflowY: "auto",
                              backgroundColor: "#fff",
                              border: "1px solid #ddd",
                              borderRadius: "4px",
                              boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
                              zIndex: 1000,
                              marginTop: "2px",
                            }}
                            onClick={(e) => {
                              e.stopPropagation(); // Prevent event from bubbling to document
                              setShowSuggestions(false); // Close when clicked
                            }}
                          >
                            <div
                              style={{
                                padding: "8px 12px",
                                fontSize: "0.8rem",
                                color: "#666",
                                borderBottom: "1px solid #eee",
                                backgroundColor: "#f8f9fa",
                              }}
                            >
                              Existing matching Skill:
                            </div>
                            <ul
                              style={{
                                listStyle: "none",
                                padding: 0,
                                margin: 0,
                              }}
                            >
                              {filteredSuggestions.map((suggestion, index) => (
                                <li
                                  key={index}
                                  style={{
                                    padding: "8px 12px",
                                    fontSize: "0.9rem",
                                    borderBottom: "1px solid #eee",
                                    color: "#333",
                                    cursor: "pointer",
                                  }}
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    setFormData((prev) => ({
                                      ...prev,
                                      Name: suggestion,
                                    }));
                                    setShowSuggestions(false);
                                  }}
                                >
                                  {suggestion}
                                </li>
                              ))}
                            </ul>
                          </div>
                        )}
                        {errors.Name && (
                          <div className="invalid-feedback">{errors.Name}</div>
                        )}
                      </div>
                    </div>
                  </div>
                  <div className="col-12">
                    <div class="mb-3">
                      <label for="Description" class="form-label">
                        Description
                      </label>
                      <textarea
                        type="text"
                        className="form-control"
                        id="Description"
                        aria-describedby="Description"
                        name="Description"
                        placeholder="Description"
                        value={formData.Description}
                        onChange={(e) =>
                          setFormData({
                            ...formData,
                            Description: e.target.value,
                          })
                        }
                      />
                    </div>
                  </div>
                  <div className="d-flex gap-2">
                    <div className="">
                      <input
                        className="form-check-input"
                        type="checkbox"
                        name="IsInActive"
                        id="flexSwitchCheckChecked"
                        checked={formData.IsInActive === 1}
                        onChange={(e) =>
                          setFormData({
                            ...formData,
                            IsInActive: e.target.checked ? 1 : 0,
                          })
                        }
                      />
                    </div>
                    <div>
                      <label
                        htmlFor="flexSwitchCheckChecked"
                        className="form-label"
                      >
                        Active
                      </label>
                    </div>
                  </div>
                </div>
                <div className="col-12 col-xl-7 p-0">
                  <div className="container-fluid">
                    <div className="table-responsive poc-head rounded">
                      <h5>
                        <b>Sub Skills Details</b>
                      </h5>
                      <table
                        id="poctable_head"
                        className="table table-bordered"
                      >
                        <thead className="text-center">
                          <tr>
                            <th>Sr. No.</th>
                            <th>
                              Sub Skills<span className="required">*</span>
                            </th>
                            <th>Remark</th>
                            <th>Active</th>
                            <th>Action</th>
                          </tr>
                        </thead>
                        <tbody className="text-center">
                          {formData.lines.map((line, index) => (
                            <tr key={index}>
                              <td>{index + 1}</td>
                              <td>
                                <input
                                  type="text"
                                  name="SubSkill"
                                  className={`form-control ${
                                    errors[`SubSkill${index}`]
                                      ? "is-invalid"
                                      : ""
                                  }`}
                                  value={line.SubSkill}
                                  onChange={(e) => handleChange(e, index)}
                                  style={{ width: "100%" }}
                                />
                                {errors[`SubSkill${index}`] && (
                                  <div className="invalid-feedback">
                                    {errors[`SubSkill${index}`]}
                                  </div>
                                )}
                              </td>
                              <td>
                                <input
                                  type="text"
                                  name="Remark"
                                  className="form-control"
                                  value={line.Remark}
                                  onChange={(e) => handleChange(e, index)}
                                  style={{ width: "100%" }}
                                />
                              </td>
                              <td>
                                <input
                                  className="form-check-input mt-2"
                                  type="checkbox"
                                  name="IsInActive"
                                  id="flexSwitchCheckChecked"
                                  checked={line.IsInActive === 1}
                                  onChange={(e) => handleChange(e, index)}
                                />
                              </td>
                              <td>
                                <div
                                  type="button"
                                  // onClick={() => handleDeleteLine(index)}
                                  onClick={() => {
                                    setDeleteIndex(index);
                                    setShowDeleteModal(true);
                                  }}
                                >
                                  <i
                                    className="bi bi-trash"
                                    style={{ fontSize: "1.2rem" }}
                                  ></i>
                                </div>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                      <button
                        type="button"
                        className="custom-btn mb-2"
                        onClick={handleAddLine}
                      >
                        <i className="fa fa-plus"></i>Add
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <div className="text-end">
                <button onClick={handleCancel} className="cancel-btn me-2">
                  Cancel
                </button>
                <button type="submit" className="custom-btn">
                  Submit
                </button>
              </div>
            </Form>
          </div>
        </div>
      </div>

      <Modal
        show={showDeleteModal}
        size="md"
        onHide={() => setShowDeleteModal(false)}
        centered
        backdrop="static"
      >
        <div
          style={{
            borderRadius: "12px",
            backgroundColor: "#ffffff",
            boxShadow: "0 10px 25px rgba(0, 0, 0, 0.15)",
            border: "none",
            overflow: "hidden",
          }}
        >
          {/* Header with Icon */}
          <Modal.Header
            style={{
              borderBottom: "none",
              justifyContent: "center",
              paddingBottom: "0",
              paddingTop: "32px",
              backgroundColor: "#ffffff",
            }}
          >
            <div
              style={{
                textAlign: "center",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <div
                style={{
                  width: "44px",
                  height: "44px",
                  backgroundColor: "#fee2e2",
                  borderRadius: "50%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  marginBottom: "12px",
                  color: "#dc2626",
                  boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
                  transition: "all 0.3s ease",
                  cursor: "pointer",
                }}
              >
                <i
                  className="bi bi-trash3-fill"
                  style={{
                    fontSize: "22px",
                  }}
                ></i>
              </div>

              {/* Title */}
              <h3
                style={{
                  fontWeight: "600",
                  color: "#1f2937",
                  fontSize: "20px",
                  margin: "0",
                }}
              >
                Delete Confirmation
              </h3>
            </div>
          </Modal.Header>

          {/* Body */}
          <Modal.Body
            style={{
              backgroundColor: "#ffffff",
              padding: "4px 10px",
              fontSize: "15px",
              color: "#6b7280",
              textAlign: "center",
              lineHeight: "1.5",
            }}
          >
            Are you sure you want to delete this item? This action cannot be
            undone.
          </Modal.Body>

          {/* Footer */}
          <Modal.Footer
            style={{
              borderTop: "none",
              justifyContent: "center",
              padding: "14px",
              gap: "12px",
              backgroundColor: "#ffffff",
            }}
          >
            <button
              style={{
                backgroundColor: "#f3f4f6",
                border: "1px solid #e5e7eb",
                padding: "6px 18px",
                borderRadius: "8px",
                fontWeight: "500",
                color: "#374151",
                cursor: "pointer",
                fontSize: "14px",
                transition: "all 0.2s ease",
              }}
              onClick={() => setShowDeleteModal(false)}
            >
              Cancel
            </button>
            <button
              style={{
                backgroundColor: "#27568B",
                border: "none",
                padding: "6px 18px",
                borderRadius: "8px",
                fontWeight: "500",
                color: "#ffffff",
                cursor: "pointer",
                fontSize: "14px",
                transition: "all 0.2s ease",
              }}
              onClick={handleDeleteLine}
            >
              Delete
            </button>
          </Modal.Footer>
        </div>
      </Modal>
    </>
  );
  }
};

export default CourseMasterForm;
